export const pathes = {
  BASE_PATH: "/feed",
  DEFAULT: "/",
  POST_DETAILS: "/post-details/:id",
  SUBJECT_CATEGORY: "/subject_category",
  ALL_POST_SUBJECT_CATEGORY: "/all-post-subject-category/:id",
};
